import React, {useContext, useEffect} from "react";
import Page from "../components/ui/Page";
import Holidays from "../components/holidays/Holidays";
import {PageContext} from "@lb/mlib-components";

export default function HolidaysPage(props) {
    const pageCtx = useContext(PageContext);

    useEffect(() => pageCtx.updateTitle("Settings | Holidays"), [pageCtx])

    return <Page hideBackButton>
        <Holidays load={props.load}/>
    </Page>;
};